<script lang="ts" setup>
import { Icon } from '~ds/components/ui/icon';
import { ICONS } from '~ds/lib/icons';

const props = defineProps<{
  title: string;
  defaultOpen?: boolean;
}>();

const isOpen = ref(props.defaultOpen ?? false);
</script>

<template>
  <div>
    <button
      class="flex w-full items-center justify-between px-3 py-2 text-left hover:bg-accent"
      @click="isOpen = !isOpen"
    >
      <span class="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        {{ title }}
      </span>
      <Icon
        :name="isOpen ? ICONS.arrowDown : ICONS.arrowRight"
        size="xs"
        class="text-muted-foreground"
      />
    </button>
    <div v-if="isOpen" class="pb-1">
      <slot />
    </div>
  </div>
</template>
